export enum Brand {
  FORD = 'ford',
  LINCOLN = 'lincoln'
}

export enum Language {
  ENGLISH = 'en',
  FRENCH = 'fr'
}

export enum Country {
  US = 'us',
  CANADA = 'ca'
}

export const APP_CONSTANTS = {
  FORD: 'ford',
  LINCOLN: 'lincoln',
  DEFAULT_LANGUAGE: Language.ENGLISH,
  DEFAULT_COUNTRY: Country.CANADA
};

export const REMOTE_APPLICATIONS = {
  FORD_CREDIT: 'ford-credit-app',
  FORD_CREDIT_HEADER: 'ford-credit-header',
  FORD_CREDIT_FOOTER: 'ford-credit-footer',
  FORD_PRO_HEADER: 'ford-pro-header',
  FORD_PRO_FOOTER: 'ford-pro-footer'
};

export const ONE_TRUST_DOMAIN_SCRIPT_IDS: Record<string, string> = {
  [`${Country.US}_${Brand.FORD}`]: '474f6f1e-8e77-40c9-97fd-ab58b6e08de0',
  [`${Country.US}_${Brand.LINCOLN}`]: 'e68b490a-bbfa-4cf0-a492-de3c092da1df',
  [`${Country.CANADA}_${Brand.FORD}`]: '36e4189f-d97e-4c35-9018-e1755788c7dc',
  [`${Country.CANADA}_${Brand.LINCOLN}`]: 'a68d239d-f6d3-439b-b094-f643bf6530b7',
  default: '474f6f1e-8e77-40c9-97fd-ab58b6e08de0'
};

export enum AEMDefaultPagePaths {
  MAINTENANCE_PAGE_PATH = '/root/maintenance',
  PAGE_NOT_FOUND = '/root/404'
}
